// extracted by mini-css-extract-plugin
export default {"Comment":"styleV2_Comment__oXRa2","invalidInput":"styleV2_invalidInput__seNLf","pulsate":"styleV2_pulsate__I6KoV"};